// flutter-notification.service.ts
import { Injectable } from '@angular/core';
import { ADD_FAVOURITE, ADD_SEARCH, DELETE_SEARCH, UserPreferenceEvent } from '../models/user-favourite-event';
import { UserPreferenceService } from '../../layout/home/services/user-preference.service';
import { NavigationService } from '../../core/navigation.service';
import { PlatformLocation, Location } from '@angular/common';
import { SimpleEntityDataService } from '../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';

@Injectable()
export class FlutterNotificationService {

  constructor(
    private userServices: UserPreferenceService,
    private navService: NavigationService,
    private platformLocation: PlatformLocation,
    private location: Location
  ) {}


  onFlutterAppLoaded(state: any, dataService: any = null) {
    state.addedFavourites(() => {
      this.notifyUserPreferenceEvent(ADD_FAVOURITE);
    });

    state.savedSearchName(() => {
      this.notifyEvent(ADD_SEARCH, null + '');
    });

    state.deleteLoadSearchItem(()=>{
      this.notifyDeleteLoadSearchEvent(DELETE_SEARCH, null + '');
    });

    state.hyperlinkClicked((selectedCells: any) => {
      this.showDetailsPage(selectedCells, dataService);
    });
  }

  private notifyEvent(type: number, item: string) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.item = item;
    event.source = 'saved_search';
    this.userServices.notifyEvent(event);
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userServices.notifyEvent(event);
  }

  private notifyDeleteLoadSearchEvent(type: number, item: string) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.item = item;
    event.source = 'delete_search';
    this.userServices.notifyEvent(event);
  }

  private showDetailsPage(selectedCells: any, dataService: any) {
    if (!dataService) {
      return;
    }

    const selectedDetailrows: any[] = JSON.parse(selectedCells)['selectedCells'];

    if (selectedDetailrows.length > 0) {
      selectedDetailrows.forEach(element => {
        let isSelected = element['isSelected'];
        let cellId = element['cellId'];
        // Open in same tab
        if (!isSelected) {
          this.navService.navigateWithRouteParams(dataService.getEntityConfiguration().getDetailPageRoute(), cellId);
        }
        // Open in new tab 
        else {
          const detailPageUrl = (this.platformLocation as any).location.origin
            + this.location['_baseHref'] +
            dataService.getEntityConfiguration().getDetailPageRoute() + '/'
            + encodeURIComponent(cellId);
          // LFWM-3484 Close existing tab page if user click to open the same record again
          if (window['win' + detailPageUrl] != null) {
            window['win' + detailPageUrl].close();
          }
          window['win' + detailPageUrl] = window.open(detailPageUrl);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/flutter/flutter-notification.service.ts